import { CSSProperties } from 'react';
import { createRoot } from 'react-dom/client';
import HostedMFE from './Hosted.mfe';
import DemoMFE from './Demo.mfe';
import { ConfigProps } from './types/app';
import capitalizeFirstLetter from './helpers/capitalizeFirstLetter';
import { getProfileHostFromWindow, shouldUseHostedMFE } from './helpers/shouldUseHostedMFE';
import './index.scss';
import { performanceMetrics } from './helpers/performanceMetrics';

const appStyles = {
  display: 'grid',
  justifyContent: 'center',
  alignContent: 'center',
  height: '100vh',
  backgroundColor: '#f5f5f5',
};

const containerStyles: CSSProperties = {
  width: '500px',
  height: '600px',
  resize: 'both',
  border: '1px solid #dadada',
  overflow: 'auto',
};

// get props from query params
const urlParams = new URLSearchParams(window.location.search);

const configProps: ConfigProps = {
  appId: urlParams.get('appId') || 'pset-userprofile',
  locale: urlParams.get('locale') || 'en',
  saveText: capitalizeFirstLetter(urlParams.get('saveText')),
  cancelText: capitalizeFirstLetter(urlParams.get('cancelText')),
  continueText: capitalizeFirstLetter(urlParams.get('continueText')),
  env: (window as any).$profileEnvVars.REACT_APP_STAGE || 'dev',
  isCompanyHidden: urlParams.get('isCompanyHidden') === 'true',
  browserView: urlParams.get('browserView'),
};

const mfeAuthToken = (window as any).$profileEnvVars['X-MFE-Authorization'] || '';

const AppContents = () => {
  const profileHost = getProfileHostFromWindow();

  if (shouldUseHostedMFE(mfeAuthToken, profileHost)) {
    return <HostedMFE accessToken={mfeAuthToken} configProps={configProps} />;
  }

  return <DemoMFE configProps={configProps} />;
};

export default function App() {
  const { startMark } = performanceMetrics({
    appId: configProps.appId,
  });
  startMark('MFE-hosted-app-start');

  if (configProps.browserView === 'fullpage') return <AppContents />;

  return (
    <div className="App" style={appStyles}>
      <div style={containerStyles}>
        <AppContents />
      </div>
    </div>
  );
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);
